import React from "../../__compat__/react/main.entry.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { pickDataProps, pickAriaProps, pickComponentCommonProps, } from "../../interfaces/commonProps.mjs.mjs";
import { StyledRectangularSkeletonShape, StyledCircularSkeletonShape, StyledOvalSkeletonShape, } from "./SkeletonShape.styles.mjs.mjs";
export const SkeletonShape = React.forwardRef(function SkeletonShape({ 'data-testid': testId, variant, width, height, aspectRatio, ...restProps }, forwardRef) {
    const getHeight = () => {
        if (height) {
            return height;
        }
        if (aspectRatio) {
            return 'auto';
        }
        return '24px';
    };
    const styledSkeletonProps = {
        variant: variant || 'rectangular',
        width: width || '100px',
        height: getHeight(),
        aspectRatio,
        outerSpacing: useSpacing(restProps),
        ...pickComponentCommonProps(restProps),
        ...pickDataProps(restProps),
        ...pickAriaProps(restProps),
    };
    switch (styledSkeletonProps.variant) {
        case 'circular':
            return (React.createElement(StyledCircularSkeletonShape, { ...styledSkeletonProps, ref: forwardRef, "data-testid": testId, "aria-hidden": true }));
        case 'rectangular':
            return (React.createElement(StyledRectangularSkeletonShape, { ...styledSkeletonProps, ref: forwardRef, "data-testid": testId, "aria-hidden": true }));
        case 'oval':
            return (React.createElement(StyledOvalSkeletonShape, { ...styledSkeletonProps, ref: forwardRef, "data-testid": testId, "aria-hidden": true }));
    }
});
//# sourceMappingURL=SkeletonShape.mjs.mjs.map